import { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom'

const PrivateRoute = ({isLoggedIn, isLoading }) => {

    if (isLoading) {
        return <div className='d-flex justify-content-center text-center h-100'>Loading...</div>;
      }
 
    return(
        isLoggedIn ? <Outlet/> : <Navigate to="/login"/>
    )
}

export default PrivateRoute